module.exports = __webpack_public_path__ + "img/kasasaLogoNew.c72b7adf.svg";